/**
 * Created by supunm on 1/21/19.
 */

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name trackingDiscrepancy.service:trackingDiscrepancyService
   *
   * @description
   *
   */
  angular
    .module('trackingDiscrepancy')
    .service('trackingDiscrepancyService', trackingDiscrepancyService);

  function trackingDiscrepancyService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchTrackingDiscrepancy = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchTrackingDiscrepancy(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      console.log("param :", param)
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        startTime : param.startTime,
        endTime : param.endTime,
        flightCategory: setFlightCategory(param),
        noOfDays:  param.days,
        aircraftType: (param.aircraftType != null) ? param.aircraftType.airCraftType : null,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        crewBase:(param.crewBase !=null ) ? param.crewBase.airPortCode : null,
        flightStatus:(param.flightStatus !=null ) ? param.flightStatus.flightStatusCode : null,
        patternType:(param.patternType !=null ) ? param.patternType.map(function(item) { return item.type; }) : null,
        acmiCode:(param.acmiProvider !=null ) ? param.acmiProvider.acmiCode:null,
        distributionGroupsList: (param.distributionGroupsList != null) ? getDistributionGroupsList(param.distributionGroupsList) : [],
        condition: param.condition ? "OR" : "AND",
      }

      return actualSearchParam;
    }

    function setFlightCategory(searchParams) {
      if ( searchParams.flightCategory == null){
        return "ALL";
      }else if ( !searchParams.flightCategory){
        return "StandBy Only";
      }else {
        return "Flights Only";
      }

    }

    vm.searchActiveDistributionConfigIdentifiers = function (successFn,errorFn) {
      RemoteService.searchActiveDistributionConfigIdentifiers().then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function getDistributionGroupsList(distributionGroupsList) {
      const distributionGroups = [];
      angular.forEach(distributionGroupsList, function(distributionGroup) {
        distributionGroups.push(distributionGroup.distributionGroupCode);
      });
      return distributionGroups;
    }

  }
}());
